import {Component, OnDestroy, OnInit, } from '@angular/core';
import {CidaasService} from '../../../service/cidaas.service';
import {ActivatedRoute, Router} from '@angular/router';
import {
  IGroupClientInfoResponse,
  ISelGroupMetadata
} from '../../../model/client-info.interface';
import { Observable, Subject} from 'rxjs';
import { map, retry, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import {ISDKConfig} from '../../../model/sdk-config.interface';
import {environment} from '../../../../environments/environment';
import { GroupRequestState } from './group-selection.model';
import { CommonFunctionsService } from '../../../service/common-functions.service';

@Component({
  selector: 'app-group-selection',
  templateUrl: './group-selection.component.html',
  styleUrls: ['./group-selection.component.scss'],
})
export class GroupSelectionComponent implements OnInit, OnDestroy {

  buttonOptions: any = {
    groupSelect: {
      color: 'accent',
      text: 'GROUP_SELECTION.SELECT',
      alignment: 'right',
      type: 'proceed',
      underline: 'none',
      for: 'cidaasSubmitBtn',
      formId: 'formId',
    },
    nextGroup: {
      color: 'accent',
      alignment: 'right',
      underline: 'none',
      for: 'cidaasSubmitBtn',
      formId: 'formId',
      text: 'next',
      type: 'proceed',
      showImg: true,
    },
    prevGroup: {
      color: 'accent',
      alignment: 'left',
      underline: 'none',
      for: 'cidaasSubmitBtn',
      formId: 'formId',
      text: 'prev',
      type: 'back',
      showImg: true,
    }
  };
  allGroupData: ISelGroupMetadata[] = [];
  groupHolder: ISelGroupMetadata[] = [];
  navActive = false;
  pageSize = 5;
  currPage = 1;
  totalPages = 0;
  prevActive = false;
  nextActive = true;
  errorMessage = false;
  unsubscribe$ = new Subject();
  contentLoading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cidaasSDK: CidaasService,
    public commonFunc: CommonFunctionsService
  ) {}

  ngOnInit(): void {
    this.init();
  }

  init(): void {
    // intialising cidaas sdk
    this.initCidaasSDK({ authority: environment.base_url });
    const paramFilter$ = this.route.queryParams.pipe(
      map(params => ({
        sub : params.sub || null,
        requestId : params.requestId || null,
        trackId : params.track_id || null
      }) as GroupRequestState)
    );
    paramFilter$
      .pipe(
        tap(() => this.contentLoading = true),
        switchMap((req) => this.getGroupDetails(req.trackId, req.requestId)),
        retry(2),
        takeUntil(this.unsubscribe$)
      ).subscribe(
        (value) => {
          this.groupBuilder(value);
          this.contentLoading = false;
        },
      () => {
          this.errorMessage = true;
          this.contentLoading = false;
      }
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
  }

  initCidaasSDK(options: Pick<ISDKConfig, 'authority'>): void {
    this.cidaasSDK._initSDK(options);
  }

  getScopeDetails$(options): Observable<IGroupClientInfoResponse>{
    return this.cidaasSDK
      .getScopeDetails(options)
      .pipe(
        take(1)
      );

  }

  getGroupDetails(trackId: string, requestId: string): Observable<ISelGroupMetadata[]> {
    return this.getScopeDetails$({
      track_id: trackId,
      locale: navigator.language,
      requestId,
    }).pipe(
      map((resp: IGroupClientInfoResponse) => {
      let data: ISelGroupMetadata[] = [];
      if (resp && resp?.meta_data && resp?.meta_data?.selectableGroups) {
        data = resp?.meta_data.selectableGroups;
      }
      return data;
    })
  );
  }

  groupBuilder(value: ISelGroupMetadata[]): void {
    if (value.length > 0){
      if (value.length > this.pageSize) {
        this.groupHolder = value.slice(0, this.pageSize);
        this.navActive = true;
        this.totalPages = Math.ceil(value.length / this.pageSize);
        this.nextActive = true;
      } else {
        this.navActive = false;
        this.groupHolder = value;
      }
    } else {
      this.errorMessage = true;
    }
  }
  backForm = () => {
    this.router.navigate(['login'], {
      queryParams: {
        requestId: this.getRequestId(),
        view_type: 'login',
      },
    }).catch();
  }
  prev(): void {
    if (this.prevActive){
      this.groupHolder = this.allGroupData.slice(this.pageSize * (this.currPage - 2), this.pageSize * (this.currPage - 1));
      this.currPage -= 1;
      if (this.currPage <= 1){
        this.prevActive = false;
        this.nextActive = true;
      }
    }
  }
  next(): void {
    if (this.nextActive){
      this.groupHolder = this.allGroupData.slice(this.pageSize * this.currPage , this.pageSize * (this.currPage + 1));
      this.currPage += 1;
      if (this.currPage >= this.totalPages){
        this.nextActive = false;
        this.prevActive = true;
      }
    }
  }

  getButtonOption(item: ISelGroupMetadata): any {
    return {
      text: item.groupName,
      color: 'accent',
      type: 'proceed',
      underline: 'none',
      fullWidth: this.isNullOrEmpty(item.logoURL),
      fixedWidth: !this.isNullOrEmpty(item.logoURL)
    };
  }

  clickRedirect(groupId: string | undefined): void {
    this.contentLoading = true;
    this.cidaasSDK.mfaContinue({
      track_id: this.getTrackId(),
      selectedGroupId: groupId
    });
    this.contentLoading = false;
  }

  private getRequestId = (): string => this.route.snapshot.queryParams.requestId;
  private getTrackId = (): string => this.route.snapshot.queryParams.track_id;
  private isNullOrEmpty = (value: string | undefined) => value === undefined || value === null || value.trim().length === 0;
}
